import { useField } from 'formik';
import BaseRadioButton from './BaseRadioButton/BaseRadioButton';
import { Container } from './styles';
import { RadioButtonFieldProps } from './types';

const RadioButtonField = (props: RadioButtonFieldProps) => {
  const [field] = useField(props);
  const { children, ...baseRadioButtonProps } = props;

  return (
    <Container htmlFor={props.id}>
      <BaseRadioButton
        disabled={props.disabled}
        {...field}
        {...baseRadioButtonProps}
        onChange={field.onChange}
      />
      <BaseRadioButton.Label htmlFor={props.id}>{children}</BaseRadioButton.Label>
    </Container>
  );
};

export default RadioButtonField;
